// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"Input_wrapperComponent__PxCz8","error":"Input_error__Ke2D8"};